import { Box, Container } from "@mui/material";
import AppBar from "../components/AppBar";
import { useSidebarLayout } from "../zustand/useSidebarStore";
import NavBar from "../components/NavBar";
import DateRangePickerComponent from "../components/inputs/DateRangePicker";
import TableReferidos from "../components/tables/TableReferidos";
import { useDateRangeStore } from "../zustand/useDateRangeStore";
import { useReferidosStore } from "../zustand/useReferidosStore";

export default function ReferidosRoute() {
  const sidebar = useSidebarLayout();
  const { fechaInicio, fechaFin, setFechas } = useDateRangeStore();
  const { resetReferidos, fetchCounts, fetchNextPage } = useReferidosStore();

  function fetchData() {
    resetReferidos();
    fetchCounts();
    fetchNextPage();
  }


  return (
    <>
      <AppBar />
      <Container maxWidth={false} sx={{ mt: 1, p: 1, ...sidebar }}>
        <NavBar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            marginTop: 2,
          }}
        >
          <DateRangePickerComponent
            start={fechaInicio}
            end={fechaFin}
            setDate={setFechas}
            handleChange={fetchData}
          />
        </Box>
        <TableReferidos />
      </Container>
    </>
  );
}
